import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class JsonldService {  
  private jsonLdData: object = {};
  setJsonLdData(data: object) {
    this.jsonLdData = data;
  }
  getJsonLdData() {
    return this.jsonLdData;
  }
}
